<template>
  <div>
    <headerNav title="返利小金库" />
    <!-- <div class="mz-main">
      <div style="text-align: center">
        <div class="mz-main-tit">大货小金库</div>
        <div>
          <span class="mz-main-pp">￥</span>
          <span class="mz-main-price">{{ abp.userInfo.referralReward }}</span>
        </div>
        <van-button
          class="vbut"
          color="rgb(247, 123, 4)"
          icon="share-o"
          type="info"
          round
          @click="showwithdrawDialog(1)"
          >提现</van-button
        >
        <van-button
          class="vbut"
          color="rgb(247, 123, 4)"
          icon="share-o"
          type="info"
          round
          @click="showwithdrawDialog(2)"
          >转余额</van-button
        >
        <van-button
          class="vbut"
          color="rgb(247, 123, 4)"
          icon="plus"
          type="info"
          round
          @click="goto('referralrewardrecord')"
          v-if="abp.userInfo&&abp.userInfo.memberLevelModel&&abp.userInfo.memberLevelModel.isTop"
          >明细查询</van-button
        >
      </div>
    </div> -->
    <div class="mz-main">
      <div>
        <!-- <div class="mz-main-tit">辅料小金库</div> -->
        <div class="cheader" v-if="abp.userInfo">
          <div class="cmoneys" :style="{color:$abctheme.basefzcolor}">
                <div class="cmoney-wz">
                    可用余额
                </div>
                <div class="cmoney-money">
                    <div><span>￥</span>{{abp.userInfo.privateCoffer||"0.00"}}</div>
                </div>
          </div>
          <div class="cmoneys" :style="{color:$abctheme.basefzcolor}">
                <div class="cmoney-wz">
                    冻结中金额
                </div>
                <div class="cmoney-money">
                    <div><span>￥</span>{{abp.userInfo.freezePrivateCoffer||"0.00"}}</div>
                </div>
          </div>
        </div>

       
        
          <!-- <div class="cmoneys" >
                <div class="cmoney-wz">
                    可用余额:
                </div>
                <div class="cmoney-money">
                    <div><span>￥</span>{{userInfo.siDongFenRun||"0.00"}}</div>
                </div>
            </div>
          <span class="mz-main-pp">可用余额:￥</span>
          <span class="mz-main-price">{{ abp.userInfo.privateCoffer }}</span>
        </div>
         <div>
          <span class="mz-main-pp">冻结中金额:￥</span>
          <span class="mz-main-price">{{ abp.userInfo.freezePrivateCoffer }}</span>
        </div> -->

        <van-button
          class="vbut setbtns"
          :color="$abctheme.basecolor"
          icon="share-o"
          type="info"
          round
          @click="showwithdrawDialog(3)"
          >提现</van-button
        >
        <van-button
          class="vbut setbtns"
          :color="$abctheme.basecolor"
          icon="share-o"
          type="info"
          round
          @click="showwithdrawDialog(4)"
          >转余额</van-button
        >
        <van-button
          class="vbut setbtns"
          :color="$abctheme.basecolor"
          icon="plus"
          type="info"
          round
          @click="goto('coffer')"
          >明细查询</van-button
        >
      </div>
    </div>
    <van-dialog
      v-model="showwithdraw"
      :title="showwithdrawTitle"
      show-cancel-button
      @confirm="withdraw"
    >
      <van-field v-model="money" label="金额" input-align="right" />
      <van-radio-group v-model="method" v-if="withdrawtype == 2 || withdrawtype == 4">
        <van-cell-group>
          <van-cell title="转大货货款" clickable @click="method = '0'">
            <template #right-icon>
              <van-radio name="0" />
            </template>
          </van-cell>
          <van-cell title="转辅料货款" clickable @click="method = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showwithdraw: false,
      showwithdrawTitle: "提现金额",
      withdrawtype: 0,
      money: "",
      method: "0",
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    showwithdrawDialog(e) {
      this.showwithdrawTitle = "";
      this.withdrawtype = e;
      if (e == 1 || e == 3) {
        if (!this.abp.userInfo.wxPramOpenId) {
          this.$dialog.confirm({
            title:'未绑定微信,无法申请提现',
            message:'点击确定前往微信绑定!'
          })
          .then(()=>{
            this.$router.push({
              name:'set'
            })
          })
          return;
        }
        this.showwithdrawTitle = "提现申请";
      }
      if (e == 2 || e == 4) {
        this.showwithdrawTitle = "转货款申请";
      }
      this.showwithdraw = true;
    },
    withdraw() {
      if (!this.money) {
        this.$dialog.alert({ message: "请输入正确的金额" });
        return;
      }
      if (this.withdrawtype == 1) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/ApplyReferralRewardWithdraw?money=" +
              this.money
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
      if (this.withdrawtype == 2) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/ReferralRewardToLargeLoans?money=" +
              this.money +
              "&method=" +
              this.method
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
      if (this.withdrawtype == 3) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/ApplyPrivateCofferAccessoriesLoansWithdraw?money=" +
              this.money
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
      if (this.withdrawtype == 4) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/PrivateCofferToAccessoriesLoans?money=" +
              this.money +
              "&method=" +
              this.method
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
    },
    goto(e) {
      this.$router.push({
        name: e,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mz-main {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #bbb;
  text-align: center;
  padding: 10px 0 20px 0;
  font-size: 25px;
  margin: 10px 10px 20px 10px;
  color: rgb(247, 123, 4);
}

.mz-main-tit {
  font-size: 25px;
}

.mz-main-pp {
  font-size: 30px;
}

.mz-main-price {
  font-size: 30px;
  color: red;
}

.vbut {
  width: 70%;
  margin-top: 20px;
}
.cheader{
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    text-align: left;
    border-bottom:1px solid #e6e6e6;
}
.cmoneys
{
    display: inline-block;
    width: 50%;
    font-size: 14px;
    color:rgb(247, 123, 4);
}
.cmoney-money
{
    font-size: 25px;
}
.cbtns{
    font-size: 20px;
}
</style>
